import { render, staticRenderFns } from "./VaffColorField.vue?vue&type=template&id=7ce837ce&scoped=true&"
import script from "./VaffColorField.vue?vue&type=script&lang=js&"
export * from "./VaffColorField.vue?vue&type=script&lang=js&"
import style0 from "./VaffColorField.vue?vue&type=style&index=0&id=7ce837ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce837ce",
  null
  
)

export default component.exports